import { normalizeReportTimeValue } from '../functions/sendReport';

/** Previous cumulative play time from `getGameStages` (stages.time before this submit). */
export function readPreviousTimeSeconds(stageData) {
  if (stageData?.previousTimeSeconds != null) {
    return normalizeReportTimeValue(stageData.previousTimeSeconds);
  }
  if (stageData?.report?.time != null) {
    return normalizeReportTimeValue(stageData.report.time);
  }
  return 0;
}

/** Align sendReport (cumulative) with updateStageProgress (stage delta). */
export function buildCumulativeStageTimes(stageData, currentStageSeconds) {
  const previousTimeSeconds = readPreviousTimeSeconds(stageData);
  const currentTimeSeconds = Math.max(0, Math.floor(Number(currentStageSeconds) || 0));
  return {
    previousTimeSeconds,
    currentTimeSeconds,
    cumulativeTimeSeconds: previousTimeSeconds + currentTimeSeconds,
  };
}

/** Cumulative time from updateStageProgress response (authoritative after DB write). */
export function readCumulativeTimeFromProgress(progressResult) {
  const raw = progressResult?.report?.time;
  if (raw == null || String(raw).trim() === '') return null;
  return raw;
}

/** Previous cumulative score from `getGameStages` (stages.points/total_score before this submit). */
export function readPreviousScoreFromStageData(stageData) {
  const report = stageData?.report;
  if (!report) return 0;
  const total = Number(report.total_score);
  const points = Number(report.points);
  if (Number.isFinite(total) && total >= 0) return Math.floor(total);
  if (Number.isFinite(points) && points >= 0) return Math.floor(points);
  return 0;
}

/** Align sendReport (cumulative) with updateStageProgress (stage delta). */
export function buildCumulativeStageScore(stageData, currentStagePoints) {
  const previousScore = readPreviousScoreFromStageData(stageData);
  const currentScore = Math.max(0, Math.floor(Number(currentStagePoints) || 0));
  return {
    previousScore,
    currentScore,
    cumulativeScore: previousScore + currentScore,
  };
}

/** Cumulative score from updateStageProgress response (authoritative after DB write). */
export function readCumulativeScoreFromProgress(progressResult) {
  const report = progressResult?.report;
  if (!report) return null;
  const total = Number(report.total_score);
  const points = Number(report.points);
  if (Number.isFinite(total) && total >= 0) return Math.floor(total);
  if (Number.isFinite(points) && points >= 0) return Math.floor(points);
  return null;
}
